{
    "additional_demo": {
       "attributes":[
        {
            "attribute_ID": "isSnapReceived",
            "fieldName": "isSnapReceived",
            "label": "Do you receive Supplemental Nutrition Assistance Program (SNAP)?",
            "type": "radio",
            "mandatory": "N",
            "validator": null,
            "isAvailable": "Y"
        },
        {
            "attribute_ID": "isTanfReceived",
            "fieldName": "isTanfReceived",
            "label": "Do you receive Temporary Assistance for Needy Families (TANF)?",
            "type": "radio",
            "mandatory": "N",
            "validator": null,
            "isAvailable": "Y"
        },
        {
            "attribute_ID": "isSsiReceived",
            "fieldName": "isSsiReceived",
            "label": "Do you receive Supplemental Security Income (SSI)?",
            "type": "radio",
            "mandatory": "N",
            "validator": null,
            "isAvailable": "Y"
        },
        {
            "attribute_ID": "isUnemployed",
            "fieldName": "isUnemployed",
            "label": "Have you been unemployed for at least 27 consecutive weeks/6.2 months and received unemployment benefits during that time?",
            "type": "radio",
            "mandatory": "N",
            "validator": null,
            "isAvailable": "Y"
        },
        {
            "attribute_ID": "isVeteran",
            "fieldName": "isVeteran",
            "label": "Are you a Veteran?",
            "type": "radio",
            "mandatory": "N",
            "validator": null,
            "isAvailable": "Y"
        },
        {
            "attribute_ID": "isDisabilityComp",
            "fieldName": "isDisabilityComp",
            "label": "Are you entitled to compensation for a service-connected disability?",
            "type": "radio",
            "mandatory": "N",
            "validator": null,
            "isAvailable": "Y"
        },
        {
            "attribute_ID": "isWotcCertified",
            "fieldName": "isWotcCertified",
            "label": "I certify that the information provided above for additional demographics is correct.",
            "type": "radio",
            "mandatory": "N",
            "validator": null,
            "isAvailable": "Y"
        }
       ],    
       "validations": [
        {
            "whatToCheck": "atLeastXEntered",
            "clientOrServer": "C",
            "attributes": []
        },
        {
            "whatToCheck": "checkFieldValue",
            "clientOrServer": "C",
            "attributes": []
        },
        {
            "whatToCheck": "conditionalCheck",
            "clientOrServer": "C",
            "attributes": []
        },
        {
            "whatToCheck": "customValidator",
            "clientOrServer": "C",
            "attributes": []
        }
    ],
    "actions": [
        {
            "Name": "Previous",
            "Validate": null
        },
        {
            "Name": "Next",
            "Validate": [
                {
                    "checkType": "atLeastXEntered",
                    "validatorid": [ ]
                },
                {
                    "checkType": "checkFieldValue",
                    "validatorid": []
                },
                {
                    "checkType": "conditionalCheck",
                    "validatorid": []
                },
                {
                    "checkType": "customValidator",
                    "validatorid": []
                }
            ]
        }
    ]
   }
}